/**
 * Inset application sidebar for authenticated workspace routes: workspace
 * switcher + collapse trigger in the header, RBAC-gated nav in the body, user
 * menu in the footer. Composed from the `@cometchat-ai/ui-dashboard` sidebar
 * primitives.
 *
 * Revamped to the "Final" (Attio) look: a slim white surface defined by a single
 * hairline right border (no filled backdrop). The collapse trigger sits inline
 * with the workspace switcher.
 */

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarTrigger,
} from "@cometchat-ai/ui-dashboard";
import type * as React from "react";

import { SidebarNav } from "./side-nav";
import { UserMenu } from "./user-menu";
import { WorkspaceSwitcher } from "./workspace-switcher";

export function AppSidebar(props: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar
      collapsible="icon"
      className="group-data-[side=left]:border-r-0 [&_[data-sidebar=sidebar]]:border-r [&_[data-sidebar=sidebar]]:border-[color:color-mix(in_oklch,var(--color-border)_55%,transparent)] [&_[data-sidebar=sidebar]]:bg-background"
      {...props}
    >
      <SidebarHeader className="px-2 pt-2">
        <div className="flex items-center gap-1">
          <div className="min-w-0 flex-1">
            <WorkspaceSwitcher />
          </div>
          <SidebarTrigger className="h-7 w-7 shrink-0 rounded-md !border-0 !shadow-none !outline-none !ring-0 text-[color:var(--color-fg-subtle)] hover:!bg-[color:color-mix(in_oklch,var(--color-fg)_4%,transparent)] focus-visible:!ring-0 group-data-[collapsible=icon]:hidden" />
        </div>
      </SidebarHeader>
      <SidebarContent>
        <SidebarNav />
      </SidebarContent>
      <SidebarFooter className="px-2 pb-3">
        <UserMenu />
      </SidebarFooter>
    </Sidebar>
  );
}
